const input = document.querySelector('.js-search-input');
const clearButton = document.querySelector('.js-clear-input-btn');

if (input) {
    clearButton.addEventListener('click', () => {
        input.value = '';

        clearButton.classList.remove('check');
    });

    input.addEventListener('input', () => {
        if (input.value.length > 0) {
            clearButton.classList.add('check');
        } else {
            clearButton.classList.remove('check');
        }
    });
}
